export type CardName = string;

export const CARD_NAME = "CardName";
